import { Field, FastField } from 'formik';

import FormField from './FormField';
import Combobox from './Combobox';

// If you need to extend Combobox functionality keep in mind that {...props} is on FormControl to support all Chakra props
// Specific props for Combobox should be excluded from ...props and manually added
const FormFieldComponent = ({
    field,
    meta,
    form,
    options,
    valueKey,
    labelKey,
    onChange,
    onBlur,
    showPlaceholder,
    placeholderValue,
    placeholderLabel,
    isDisabled,
    isControlled,
    hasDivider,
    ...props
}) => {
    const isInvalid = meta.error && meta.touched;

    return (
        <FormField name={field.name} isInvalid={isInvalid} isDisabled={isDisabled} error={meta.error} {...props}>
            <Combobox
                {...field}
                onChange={(val) => {
                    form.setFieldValue(field.name, val);

                    //   Additional onChange logic could be hooked
                    if (onChange) {
                        onChange(val);
                    }
                }}
                onBlur={() => {
                    form.setFieldTouched(field.name, true, false);

                    //   Additional onBlur logic could be hooked
                    if (onBlur) {
                        onBlur();
                    }
                }}
                options={options}
                valueKey={valueKey}
                labelKey={labelKey}
                isInvalid={isInvalid}
                isDisabled={isDisabled}
                showPlaceholder={showPlaceholder || field.value == null}
                placeholderValue={placeholderValue}
                placeholderLabel={placeholderLabel}
                isControlled={isControlled}
                hasDivider={hasDivider}
            />
        </FormField>
    );
};

const ComboboxFormikField = ({ name, validate, isFastField = false, ...props }) => (
    <>
        {isFastField ? (
            <FastField name={name} validate={validate}>
                {({ field, meta, form }) => <FormFieldComponent field={field} meta={meta} form={form} {...props} />}
            </FastField>
        ) : (
            <Field name={name} validate={validate}>
                {({ field, meta, form }) => <FormFieldComponent field={field} meta={meta} form={form} {...props} />}
            </Field>
        )}
    </>
);

export default ComboboxFormikField;
